import FormField from "@/components/common/FormField"
import MainHeading from "@/components/common/MainHeading"
import Layout from "@/components/layout/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { useForm } from "react-hook-form"
import { errorTypes } from "@/utility/validation"
import { Button } from "@/components/ui/button"
import Card from "@/components/common/Card"
import { ThrowError } from "@/api/callApi"
import ShiftAndTimeService from "@/services/ShiftAndTime/ShiftAndTime"
import type { shiftAndTime, IshiftAndTimeResponse } from "@/interface/shiftAndTime.interface"
import { showToastNotification } from "@/utility/helper"
import { RoutesLink } from "@/utility/RouteLinks"
import { useEffect, useState } from "react"

const AddShiftAndTime: React.FC = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<shiftAndTime>({});

    console.log("errors", errors)

    const handleGetShiftAndTimeById = async () => {
        if (!id) return;
        try {
            const response = await ShiftAndTimeService?.getShiftAndTimeById(id);
            if (response?.status) {
                setValue("shiftName", response?.data?.shiftName)
                setValue("startTime", response?.data?.startTime)
                setValue("endTime", response?.data?.endTime)
                setValue("checkInBufferTime", response?.data?.checkInBufferTime)
                setValue("checkOutBufferTime", response?.data?.checkOutBufferTime)
                setValue("type", response?.data?.type)
                setValue("isActive", response?.data?.isActive)
            }
            else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)
        }
    }

    useEffect(() => {
        if (id) {
            handleGetShiftAndTimeById();
        }
    }, [id]);

    const onSubmit = async (data: shiftAndTime) => {
        try {
            setIsLoading(true)
            const payload = {
                shiftName: data.shiftName,
                startTime: data.startTime,
                endTime: data.endTime,
                checkInBufferTime: data.checkInBufferTime,
                checkOutBufferTime: data.checkOutBufferTime,
                type: data.type,
                // isActive: String(data.isActive) === "true",
            }
            let response: IshiftAndTimeResponse;
            if (id) {
                response = await ShiftAndTimeService?.updateShiftAndTime(payload as any, id);
            } else {
                response = await ShiftAndTimeService?.createShiftAndTime(payload as any);
            }
            if (response?.status) {
                showToastNotification("success", response?.message)
                navigate(RoutesLink.shiftAndTime)
            } else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading
                    title={id ? "Edit Shift and Time" : "Add Shift and Time"}
                    onClick={() => { navigate(-1) }}
                    isBackButtonVisible
                />
                <Card>
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("shiftName", { ...errorTypes.required('Shift Name') })}
                                type="text"
                                label="Shift Name"
                                placeholder="Enter Shift Name"
                                error={errors.shiftName?.message}
                            />
                            <FormField
                                {...register("type", { ...errorTypes.required('Type') })}
                                type="select"
                                value={String(watch("type"))}
                                label="Type"
                                options={[
                                    { value: "select", label: "Select Type" },
                                    { value: "office", label: "Office" },
                                    { value: "field", label: "Field" },
                                ]}
                                error={errors.type?.message}
                            />
                            <FormField
                                {...register("startTime", { ...errorTypes.required('Start Time') })}
                                type="time"
                                label="Start Time"
                                error={errors.startTime?.message}
                            />
                            <FormField
                                {...register("endTime", { ...errorTypes.required('End Time') })}
                                type="time"
                                label="End Time"
                                error={errors.endTime?.message}
                            />
                            <FormField
                                {...register("checkInBufferTime", { ...errorTypes.required('Check-in Buffer') })}
                                type="time"
                                label="Check-in Buffer"
                                placeholder="Enter minutes"
                                error={errors.checkInBufferTime?.message}
                            />
                            <FormField
                                {...register("checkOutBufferTime", { ...errorTypes.required('Check-out Buffer') })}
                                type="time"
                                label="Check-out Buffer"
                                placeholder="Enter minutes"
                                error={errors.checkOutBufferTime?.message}
                            />
                            {/* <FormField
                                {...register("isActive", { ...errorTypes.required("Status") })}
                                type="select"
                                value={id ? String(watch("isActive")) : "select"}
                                options={[
                                    { value: "select", label: "Select Status" },
                                    { value: "true", label: "Active" },
                                    { value: "false", label: "Inactive" },
                                ]}
                                label="Status"
                                error={errors.isActive?.message}
                            /> */}
                        </div>
                        <div className="flex justify-end">
                            <Button disabled={isLoading} type="submit">{isLoading ? "Submitting..." : "Submit"}</Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>
    )
}

export default AddShiftAndTime;